import { MapContainer, LayersControl, TileLayer } from "react-leaflet";
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { SchadflaechenLayer } from './Layer/SchadflaechenLayer';
import { SchadflaechenSelectedLayer } from './Layer/SchadflaechenSelectedLayer';
import { useConfig } from '../../Services/useConfig';
import LeafletControlGeocoder from './Geocoder';
import { Box } from '@mui/material';
import { ScaleControl } from 'react-leaflet';
import LegendSimple from './LegendSimple.component';
import useTranslation from '../../Language/useTranslation';
import { useLanguage } from '../../Language/LanguageContext';
import FireMarker from './FireMarker';
import Buttons from './Buttons';
import MapInteraction from './MapInteraction';
import WaldzustandsTileLayer from './Layer/WaldzustandsLayer';

export default function MapArea(props) {
    const config = useConfig();
    const t = useTranslation();
    const { language } = useLanguage();
    console.log("translation", t);

    const [inIframe, setInIframe] = useState(false);
    const [mapKey, setMapKey] = useState(0);

    const darkMapUrl = `https://tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token=${config["general"].jawgApiKey}`;
    const leftOffset = 15;

    useEffect(() => {
        if (window.location !== window.parent.location) {
            setInIframe(true);
        }
    }, []);

    useEffect(() => {
        // Change mapKey whenever the translation object or active layer changes
        setMapKey(prevKey => prevKey + 1);
    }, [t, language]);

    const mapButtonClicked = (subdrawerType) => {
        switch (subdrawerType) {
            case "LAYER":
                props.setActiveLayer(t["layersWaldzustand"][props.tabIndexWaldzustand].label);
                break;
            case "BAUMARTEN":
                props.setActiveLayer(t["layersBaumarten"][0].label);
                break;
            case "FIRE":
                props.setActiveLayer(t["layersFeuer"][0].label);
                break;
            case "SCHADEN":
                props.setActiveLayer(t["layersSchaden"][0].label);
                break;
        }
        props.setLeftSubDrawerType(subdrawerType);
    };

    const fullScreen = () => {
        window.open("https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland");
    };

    return (
        <Box position="fixed" sx={{ width: "100%" }}>
            {props.mobile &&
                <Buttons
                    fullScreen={fullScreen}
                    mapButtonClicked={mapButtonClicked}
                    leftOffset={leftOffset}
                    {...props}
                />
            }
            <LegendSimple
                key={mapKey}
                activeLayer={props.activeLayer}
                mobile={props.mobile}
                setLeftSubDrawerOpen={props.setLeftSubDrawerOpen}
                setLeftSubDrawerType={props.setLeftSubDrawerType}
                leftSubDrawerOpen={props.leftSubDrawerOpen}
            />
            <Grid item className="map-container" xs={12}>
                <MapContainer
                    key={mapKey}
                    className="map-container"
                    scrollWheelZoom={true}
                    zoomControl={false}
                    maxZoom={13}
                    minZoom={6}
                    maxBounds={[[42.3024876979, -5.98865807458], [59.983104153, 25.0169958839]]}
                    bounds={[[49.3956634, 7.0300363], [53.053473, 10.3863514]]}
                >
                    <LeafletControlGeocoder />
                    <ScaleControl position="bottomright" />

                    {props.activeLayer === "fire" && <FireMarker {...props}></FireMarker>}

                    {props.activeLayer === t["layersBaumarten"][0].label && (
                        <TileLayer
                            key={t["layersBaumarten"][0].label}
                            url={t["layersBaumarten"][0].url}
                            zIndex={10}
                        />
                    )}

                    {props.activeLayer.includes("wald") && (
                        <WaldzustandsTileLayer key={props.activeLayer + props.version} activeLayer={props.activeLayer} version={props.version} />
                    )}

                    {props.activeLayer === t["layersSchaden"][0].label && (
                        <TileLayer
                            key={t["layersSchaden"][0].label}
                            url={t["layersSchaden"][0].url}
                            zIndex={10}
                        />
                    )}

                    <SchadflaechenSelectedLayer
                        setSelectedAreaId={props.setSelectedAreaId}
                        selectedAreaId={props.selectedAreaId}
                        setBundesland={props.setBundesland}
                    />
                    <SchadflaechenLayer
                        setSelectedAreaId={props.setSelectedAreaId}
                        selectedAreaId={props.selectedAreaId}
                    />
                    <MapInteraction mapBounds={props.mapBounds} />

                    <LayersControl position="topright">
                        <LayersControl.BaseLayer checked name={t.baseLayers.satellite.name} key={`satellite-${t.baseLayers.satellite.name}`}>
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name={t.baseLayers.dark.name} key={`dark-${t.baseLayers.dark.name}`}>
                            <TileLayer
                                url={darkMapUrl}
                                attribution='<a href="https://www.jawg.io" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a> contributors'
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name={t.baseLayers.map.name} key={`map-${t.baseLayers.map.name}`}>
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                        </LayersControl.BaseLayer>
                    </LayersControl>
                </MapContainer>
            </Grid>
        </Box>
    );
}